<div class="mb-3 p-3 rounded border bg-white shadow-sm">
    <h5 class="mb-3">Presentation</h5>
    <div class="mb-4">Please prepared your presentation/document here. After uploaded presentation, 
        the file will be automatically shown in the system for investors to download.
    </div>

    <div>Attach Files <span class="text-danger">*</span></div>
    <div class="mt-2 mb-3">
        <input
            #fileInput
            type="file"
            class="d-none"
            accept=".pptx,.pdf,.jpg,.png"
            (change)="onFileSelected($event)">
        <button
            type="button"
            class="btn btn-outline-primary upload-btn"
            (click)="fileInput.click()"
            [disabled]="!canUploadFile">
            <i class="fas fa-paperclip mr-2 paperclip-icon"></i>
            Upload Files
        </button>
    </div>

    <div class="mb-4 upload-help-text">You can upload files in the following formats: .pptx, .pdf, .jpg, and .png (Maximum file size: 20MB.)</div>

    <div *ngIf="displayFileName" class="uploaded-file-tag mb-2">
        <div class="uploaded-file-left">
            <i [class]="getFileIconClass(displayFileName)"></i>
            <button type="button" class="uploaded-file-name btn-link-plain ml-2" (click)="downloadFile()">{{displayFileName}}</button>
        </div>
        <button type="button" class="uploaded-file-remove" (click)="removeFile()" aria-label="Remove file">
            <i class="fas fa-times"></i>
        </button>
    </div>
</div>

<div class="d-flex justify-content-end">
    <button class="btn btn-primary" (click)="onSubmit()" [disabled]="!canSavePresentation">Save</button>
</div>